import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 24 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Section({ id, className = "", children, grid = false }) {
  return (
    <section id={id} className={`relative px-5 sm:px-8 lg:px-12 py-20 md:py-28 ${className}`}>
      {grid && <div className="absolute inset-0 qs-grid qs-grid-fade opacity-30 pointer-events-none" aria-hidden="true" />}
      <div className="relative mx-auto max-w-7xl">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-[#2DD4BF] ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-[#2DD4BF]" />
      {children}
    </div>
  );
}

export function SectionHeading({ eyebrow, title, sub, className = "", align = "left" }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && <Eyebrow className="mb-5">{eyebrow}</Eyebrow>}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-[1.05]">{title}</h2>
      {sub && <p className="mt-5 text-base md:text-lg text-[#94A3B8] leading-relaxed">{sub}</p>}
    </div>
  );
}

export function DemoBadge({ className = "" }) {
  return (
    <span
      data-testid="demo-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border border-amber-400/40 bg-amber-400/10 px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest text-amber-300 ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
      Demo Data — Not Live Trading Results
    </span>
  );
}

export function Placeholder({ children }) {
  return (
    <span className="font-mono text-xs rounded bg-[#0E9E90]/15 border border-[#0E9E90]/30 px-1.5 py-0.5 text-[#a5b0f5]">
      {children}
    </span>
  );
}

export function StatusPill({ status }) {
  const map = {
    ONLINE: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
    CONNECTED: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
    ACTIVE: "text-[#2DD4BF] border-[#2DD4BF]/40 bg-[#2DD4BF]/10",
    active: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
    monitoring: "text-amber-300 border-amber-400/40 bg-amber-400/10",
  };
  const cls = map[status] || "text-[#94A3B8] border-white/15 bg-white/5";
  return (
    <span className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-widest ${cls}`}>
      <span className="qs-pulse-dot h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}
